import { render, staticRenderFns } from "./OldRetailerBrandProfile.vue?vue&type=template&id=31e81bd9&lang=pug"
import script from "./OldRetailerBrandProfile.vue?vue&type=script&lang=js"
export * from "./OldRetailerBrandProfile.vue?vue&type=script&lang=js"
import style0 from "./OldRetailerBrandProfile.vue?vue&type=style&index=0&id=31e81bd9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports